import React, { FC } from 'react'
import { Form } from 'antd'
import { UISizes, UITypes, i18n } from 'LibNeo'
import { GetFieldDecoratorOptions, WrappedFormUtils } from 'antd/lib/form/Form'
import {
	SwitchAntStyle,
	SwitchIcon,
	SwitchTitle,
	SwitchContainer,
} from 'LibNeo/components/Basic/Switch/SwitchComponent/styled'

export interface SwitchProps {
	fieldName?: string
	disabled?: boolean
	title?: string
	className?: string
	fieldOptions?: GetFieldDecoratorOptions
	form?: WrappedFormUtils
	onChange?: any
	checkedChildren?: string
	unCheckedChildren?: string
	checked?: boolean
	tooltip?: string
	dataQa?: string
}

export const SwitchComponent: FC<SwitchProps> = ({
	form,
	disabled = false, // гарантирует появление атрибута data-qa-disabled, ввиду типа boolean | undef
	fieldName,
	onChange,
	fieldOptions,
	checkedChildren,
	unCheckedChildren,
	title,
	checked,
	className,
	tooltip,
	dataQa,
}) => {
	const getFieldDecorator = form?.getFieldDecorator

	const icon = Boolean(tooltip) && (
		<SwitchIcon name="help" type={UITypes.PASSIVE} size={UISizes.SMALL} tooltip={tooltip} />
	)
	const getSwitch = (): JSX.Element => {
		const checkedProp = getFieldDecorator ? {} : { checked }
		const switcher = (
			<SwitchAntStyle
				className={className}
				disabled={disabled}
				onChange={onChange}
				checkedChildren={checkedChildren}
				unCheckedChildren={unCheckedChildren}
				{...checkedProp}
				ant-click-animating={false}
				data-qa={dataQa}
			/>
		)
		if (getFieldDecorator) {
			return (
				<SwitchContainer>
					<Form.Item>
						{getFieldDecorator(fieldName, {
							// rename value prop to checked for Switch
							...{ valuePropName: 'checked' },
							...fieldOptions,
						})(switcher)}
						{title && <SwitchTitle disabled={disabled}>{i18n(title)}</SwitchTitle>}
						{icon}
					</Form.Item>
				</SwitchContainer>
			)
		}

		return (
			<SwitchContainer>
				{switcher}
				{title && <SwitchTitle disabled={disabled}>{i18n(title)}</SwitchTitle>}
				{icon}
			</SwitchContainer>
		)
	}

	return getSwitch()
}
